module.exports = __webpack_public_path__ + "img/error.2d412090.svg";